module.exports = __webpack_public_path__ + "img/sign_out.c71c9a22.svg";